import { PaymentMethod } from "@covertree/agent-portal-graphql";

export function mapPaymentMethod(paymentMethod: PaymentMethod): string {
  switch (paymentMethod) {
    case PaymentMethod.BankAccount:
      return "Bank Account";
    case PaymentMethod.CreditDebitCard:
      return "Credit Card";
    case PaymentMethod.MortgageBill:
      return "Mortgage Bill";
    default:
      return "N/A";
  }
}
